var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 588,
    zoomAndPan: "magnify",
    viewBox: "0 0 440.88 203.999996",
    height: 272,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "088c46c84a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94.519531 39.355469 L 346.453125 39.355469 L 346.453125 164.570312 L 94.519531 164.570312 Z M 94.519531 39.355469 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "7a2af25fbc"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#088c46c84a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#009623",
      fillOpacity: 1
    },
    d: "M 94.558594 72.714844 L 126.957031 72.714844 L 126.957031 86.679688 C 134.964844 75.953125 143.664062 70.136719 157.140625 70.136719 C 180.660156 70.136719 191.757812 83.953125 191.757812 108.488281 L 191.757812 161.976562 L 156.28125 161.976562 L 156.28125 114.785156 C 156.28125 105.929688 153.898438 98.097656 143.828125 98.097656 C 132.929688 98.097656 130.035156 105.070312 130.035156 116.488281 L 130.035156 161.976562 L 94.558594 161.976562 Z M 200.96875 161.976562 L 236.445312 161.976562 L 236.445312 72.714844 L 200.96875 72.714844 Z M 200.96875 64.339844 L 236.445312 64.339844 L 236.445312 39.355469 L 200.96875 39.355469 Z M 295.9375 139.007812 C 284.34375 139.007812 280.9375 126.914062 280.9375 117.378906 C 280.9375 108.191406 285.203125 97.617188 295.9375 97.617188 C 307.367188 97.617188 310.953125 108.523438 310.953125 118.058594 C 310.953125 127.773438 307.546875 139.007812 295.9375 139.007812 Z M 281.78125 39.355469 L 246.320312 39.355469 L 246.320312 162.011719 L 278.207031 162.011719 L 278.207031 149.402344 L 278.554688 149.402344 C 282.988281 157.929688 291.175781 164.570312 305.992188 164.570312 C 335.167969 164.570312 346.414062 143.273438 346.414062 116.867188 C 346.414062 89.949219 330.386719 70.1875 307.546875 70.1875 C 296.960938 70.1875 288.777344 73.59375 281.78125 81.769531 Z M 281.78125 39.355469 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.e0e12eabadb9cb1e9662b694d154c6db.svg";
export { ForwardRef as ReactComponent };